import "materialize-css/dist/css/materialize.min.css";
import "./App.css";
import axios from "axios";
import Message from "./components/Messages";
import React, { Component } from "react";
import Cookies from "universal-cookie";
import { v4 as uuid } from "uuid";


import Card from "./components/Card";
import QuickReplies from "./components/QuickReplies";

const cookies = new Cookies();
const config = require("./Config/ChatBotConfig.js");
class Chatbot extends Component {
  messagesEnd;

  constructor(props) {
    super(props);
    this._handleInputKeyPress = this._handleInputKeyPress.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this._handleQuickReplyPayload = this._handleQuickReplyPayload.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.state = {
      messages: [],
      showBot: true,
    };
    if (cookies.get("userID") === undefined) {
      cookies.set("userID", uuid(), { path: "/" });
    }
    console.log("cookie user Id", cookies.get("userID"));
  }

  componentDidMount() {
    this.df_event_query("Welcome");
    console.log("component C mounted");
  }
  componentDidUpdate() {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    if (this.talkInput) {
      this.talkInput.focus();
    }
  }

  show(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showBot: true });
  }

  hide(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showBot: true });
  }

  async df_text_query(queryText) {
    let says = {
      speaks: "user",
      msg: {
        text: {
          text: queryText,
        },
      },
    };
    this.setState({ messages: [...this.state.messages, says] });
    const res = await axios.post(config.df_text_query,
      { text: queryText, userID: cookies.get("userID") }
    );

    console.log("RE", res.data.response.fulfillmentMessages);
    for (let msg of res.data.response.fulfillmentMessages) {
      says = {
        speaks: "bot",
        msg: msg,
      };
      this.setState({ messages: [...this.state.messages, says] });
    }
  }

  _handleQuickReplyPayload(event, payload, text) {
    event.preventDefault();
    event.stopPropagation();

    this.df_text_query(text);
  }

  _handleInputKeyPress(e) {
    if (e.key === "Enter") {
      if (e.target.value.trim() != "") {
        this.df_text_query(e.target.value.trim());
        this.talkInput.value = "";
        e.preventDefault();
      }
    }
  }
  _handleClick(e)
  {
    if(this.talkInput.value.trim()!="")
    {
      this.df_text_query(this.talkInput.value.trim());
      this.talkInput.value = "";
    }
  }

  async df_event_query(eventName) {
    const res = await axios.post(
      config.df_event_query,
      { event: eventName, userID: cookies.get("userID") }
    );

    if (
      res &&
      res.data &&
      Array.isArray(res.data.response.fulfillmentMessages)
    ) {
      for (let msg of res.data.response.fulfillmentMessages) {
        let says = {
          speaks: "bot",
          msg: msg,
        };

        this.setState({ messages: [...this.state.messages, says] });
      }
    }
  }

  renderCards(cards) {
    return cards.map((card, i) => <Card key={i} payload={card.structValue} />);
  }

  renderOneMessage(message, i) {
    if (message.msg && message.msg.text && message.msg.text.text) {
      return (
        <Message key={i} speaks={message.speaks} text={message.msg.text.text} />
      );
    } else if (
      message.msg &&
      message.msg.payload &&
      message.msg.payload.fields &&
      message.msg.payload.fields.quick_replies
    ) {
      return (
        <QuickReplies
          text={
            message.msg.payload.fields.text
              ? message.msg.payload.fields.text
              : null
          }
          key={i}
          replyClick={this._handleQuickReplyPayload}
          speaks={message.speaks}
          payload={message.msg.payload.fields.quick_replies.listValue.values}
        />
      );
    } else if (message.msg && message.msg.payload.fields.cards) {
      //message.msg.payload.fields.cards.listValue.values

      return (
        <div key={i}>
          <div className="card-panel white lighten-5 z-depth-1">
            <div style={{ overflow: "hidden" }}>
              <div className="col s2">
                <a
                  href="/"
                  className="btn-floating btn-sm waves-effect waves-light red"
                >
                  {message.speaks}
                </a>
              </div>
              <div style={{ overflow: "auto", overflowY: "scroll" }}>
                <div
                  style={{
                    height: 300,
                    width:
                      message.msg.payload.fields.cards.listValue.values.length *
                      270,
                  }}
                >
                  {this.renderCards(
                    message.msg.payload.fields.cards.listValue.values
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  renderMessages(returnedMessages) {
    if (returnedMessages) {
      {
        console.log(returnedMessages);
      }
      return returnedMessages.map((message, i) => {
        return this.renderOneMessage(message, i);
      });
    } else {
      return null;
    }
  }

  render() {
    if (this.state.showBot) {
      return (
        <div
          style={{ border: "0px solid lightgray", }}
        >
          <div
            id="chatbot"
            
          >
            {this.renderMessages(this.state.messages)}
            <div
              ref={(el) => {
                this.messagesEnd = el;
              }}
              style={{ float: "left", clear: "both" }}
            ></div>
          </div>
          <div className="container" style={{ marginTop: 8,width: "98%",}}>
          <div class="row" >
          <div class="col s9">
            <textarea 
              style={{               
                padding: "5px",
                width: "98%",  
                outline:"none",              
              }}
              ref={(textarea ) => {
                this.talkInput = textarea ;
              }}
              placeholder="type a message:"
              onKeyPress={this._handleInputKeyPress}
              id="user_says"
              type="text"
            />
            </div>
            <div className="col s2">
              <button class="btn btn-info" id="sendMessage" style={{marginTop:10}} onClick={this._handleClick}>
                  Send
                </button>
            </div>
          </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            minHeight: 40,
            maxHeight: 500,
            width: 400,
            position: "absolute",
            bottom: 0,
            right: 0,
            border: "1px solid lightgray",
          }}
        >
          <nav>
            <div className="nav-wrapper">
              <a href="/" className="brand-logo">
                ChatBot
              </a>
              <ul id="nav-mobile" className="right hide-on-med-and-down">
                <li>
                  <a href="/" onClick={this.show}>
                    Show
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          <div
            ref={(el) => {
              this.messagesEnd = el;
            }}
            style={{ float: "left", clear: "both" }}
          ></div>
        </div>
      );
    }
  }
}
function App() {
  return (
    <div className="App">     
        <Chatbot />      
    </div>
  );
}

export default App;
